import { PriceInterface } from "@/interface/business/item.interface";
import { ExternalFeesInterface, TaxInterface } from "@/interface/business/order.interface";
import { ExternalFeesType } from "@/types/business/item.type";
import { Tax } from "@/modules/business/Tax";
import { PriceMoney } from "@/modules/location";

export class ExternalFees implements ExternalFeesInterface {
  id: string = "";
  intent: string = "";
  name: string = "";
  rate: number = 0;
  amount: number = 0;
  type: string = "";
  tax?: TaxInterface;
  total_money?: PriceInterface;
  applied_money?: PriceInterface;

  constructor(data?: ExternalFeesType) {
    if (data) {
      Object.assign(this, data);
    }

    if (data?.tax) {
      this.tax = new Tax(data.tax);
    }

    if (data?.total_money) {
      this.total_money = new PriceMoney(data.total_money);
    }

    if (data?.applied_money) {
      this.applied_money = new PriceMoney(data.applied_money);
    }
  }
}
